export default "__VITE_ASSET__BR_o1qLR__"